module.exports = __webpack_public_path__ + "static/media/football-1.c4d498a5.jpg";